export const CIRCLE_RADIUS = 6;
export const CIRCLE_OFFSET = CIRCLE_RADIUS + 2;
export const CIRCLE_BORDER_WIDTH = 1;
export const SOURCE_HANDLE_BREADTH = 24;

/**
 * Handle IDs used for ReactFlow node connections.
 * These must match the id attributes on Handle components in NodeContainer.
 */
export const HANDLE_IDS = {
  SOURCE_TOP: 'source-top',
  SOURCE_LEFT: 'source-left',
  SOURCE_RIGHT: 'source-right',
  SOURCE_BOTTOM: 'source-bottom',
  SOURCE_LEFT_CIRCLE: 'source-left-circle',
  SOURCE_RIGHT_CIRCLE: 'source-right-circle',
  TARGET_BODY: 'target-body',
  TARGET_LEFT_CIRCLE: 'target-left-circle',
  TARGET_RIGHT_CIRCLE: 'target-right-circle',
} as const;
